<template>
  <div class="gray-bg">
    <div class="pad_1 home-bg">
      <!-- 评估 -->
      <div class="flex-row home-title pad_1">
        <div
          v-for="(item, index) in iconlist"
          :key="index"
          class="home-icon-box"
          @click="clickItem(item)"
        >
          <div class="home-icon"><img :src="item.icon" alt="" /></div>
          <span>{{ item.text }}</span>
        </div>
      </div>
    </div>
    <!-- 轮播图 -->
    <div class="home-swiper-box" v-show="isWeichat">
      <mt-swipe>
        <mt-swipe-item
          ><div class="home-swiper">
            <img
              src="../../assets/home/banner5.png"
              alt=""
              @click="getshandong"
            /></div
        ></mt-swipe-item>
        <!-- <mt-swipe-item
          ><div class="home-swiper">
            <img
              src="../../assets/home/banner6.jpg"
              alt=""
              @click="getpocket"
            /></div
        ></mt-swipe-item> -->
        <mt-swipe-item
          ><div class="home-swiper">
            <img
              src="../../assets/home/banner3.png"
              alt=""
              @click="$router.push('/test/userList')"
            /></div
        ></mt-swipe-item>
      </mt-swipe>
    </div>
     <div class="home-swiper-box"  v-show="!isWeichat">
      <mt-swipe>
        <mt-swipe-item
          ><div class="home-swiper">
            <img
              src="../../assets/home/banner5.png"
              alt=""
              @click="getshandong"
            /></div
        ></mt-swipe-item>
        <!-- <mt-swipe-item
          ><div class="home-swiper">
            <img
              src="../../assets/home/banner6.jpg"
              alt=""
              @click="getpocket"
            /></div
        ></mt-swipe-item> -->
        <mt-swipe-item
          ><div class="home-swiper">
            <img
              src="../../assets/home/banner1.png"
              alt=""
              @click="$router.push('/exhibition')"
            /></div
        ></mt-swipe-item>
          <mt-swipe-item
            ><div class="home-swiper">
              <img
                src="../../assets/home/banner2.jpg"
                alt=""
                @click="$router.push('/red/quanmai')"
              /></div
          ></mt-swipe-item>
        <mt-swipe-item
          ><div class="home-swiper">
            <img
              src="../../assets/home/banner3.png"
              alt=""
              @click="$router.push('/test/userList')"
            /></div
        ></mt-swipe-item>
      </mt-swipe>
    </div>
    <div class="pad_1">
      <!-- 健康排名 -->
      <div class="flex-row home-healthy">
        <div class="home-healthy-right" @click="healthRank">
          <img
            class="home-healthy-img"
            src="../../assets/home/healthy.png"
            alt=""
          /><span>健康排名</span>
        </div>
        <div class="home-healthy-left" @click="SignDay">
          <img
            class="home-healthy-img"
            src="../../assets/home/signIn.png"
            alt=""
          /><span>签到积分</span>
        </div>
      </div>
      <!-- 健康知识 -->
      <div class="flex-row home-know-box">
        <div class="flex-row align-items">
          <div class="home-know"></div>
          <div class="font-weight">健康知识</div>
        </div>
        <div class="blue" @click="$router.push('/text/article')">查看更多</div>
      </div>
      <!-- 新闻列表 -->
      <div
        v-infinite-scroll="LoadMore"
        infinite-scroll-disabled="loading"
        infinite-scroll-distance="10"
      >
        <div
          class="flex-row home-news pad_1"
          v-for="(item, index) in newsList"
          :key="index"
          @click="NewsClick(item)"
          v-show="!item.href"
        >
          <div
            class="home-news-img"
            :style="{
              backgroundImage:
                'url(' + (item.img ? item.img : $defaultImg) + ')'
            }"
          ></div>
          <div class="flex-column home-content">
            <p>{{ item.title }}</p>
            <div class="flex-row align-items">
              <div class="flex-row align-items">
                <img
                  class="home-news-icon"
                  src="../../assets/home/scan.png"
                  alt=""
                />
                <span class="home-news-text">{{
                  item.article_click == null ? "0" : item.article_click
                }}</span>
              </div>
              <div class="flex-row align-items">
                <img
                  class="home-news-icon"
                  src="../../assets/home/like.png"
                  alt=""
                />
                <span class="home-news-text">{{
                  item.like_total == null ? "0" : item.like_total
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-footer name="home"></app-footer>
    <mt-popup v-model="popShow" popup-transition="popup-fade">
      <div>
        <div v-for="(item, index) in btnlist" :key="index" class="pad_2">
          <div class="flex-row align-items home-zhanye" @click="btnclick(item)">
            <img :src="item.src" alt="" class="home-zhanye-img" /><span>{{
              item.text
            }}</span>
          </div>
        </div>
      </div>
    </mt-popup>
     <mt-popup v-model="popupvisible">
        <div class="ps-popup-agent">
          <div class="agent-pop-title">{{this.message}}</div>
           <div class="agent-pop-btn" @click="overclose">我知道了</div>
        </div>
    </mt-popup>
  </div>
</template>
<script>
import testicon from "../../assets/home/test.png";
import zhanicon from "../../assets/home/zhanye.png";
import zhanyeicon from "../../assets/home/exhibition.png";
import conicon from "../../assets/home/connections.png";
import { Swipe, SwipeItem, Indicator, InfiniteScroll } from "mint-ui";
import appFooter from "../../components/footer";
import textService from "../../service/textService";
import userService from "../../service/userService";
import jifenService from "../../service/jifenService";
import replaceState from "../../util/replaceState";
import params from "../../service/params";
import applyService from '../../service/applyService';
export default {
  components: { appFooter },
  data() {
    return {
      newsList: [],
      page: 1,
      ahshow: "",
      id: "",
      pageSize: 10,
      allPage: 1,
      message:'',
      isWeichat: false,
      popupvisible:false,
      popShow: false,
      testicon: testicon,
      zhanicon: zhanicon,
      zhanyeicon: zhanyeicon,
      conicon: conicon,
      iconlist: [],
      iconlist1: [
        {
          icon: testicon,
          text: "健康评估",
          src: "/test/userList"
        },
        {
          icon: zhanyeicon,
          text: "展业利器",
          tip: 1,
          src: ""
        },
        {
          icon: zhanicon,
          text: "展业专区",
          src: "/exhibition/enhome"
        },
        {
          icon: conicon,
          text: "人脉管理",
          tip: 2,
          src: ""
        }
      ],
      iconlist2: [
        {
          icon: testicon,
          text: "健康评估",
          src: "/test/userList"
        },
        {
          icon: zhanyeicon,
          text: "展业利器",
          tip: 1,
          src: ""
        },
        {
          icon: zhanicon,
          text: "展业专区",
          src: "/exhibition/enhome"
        },
        {
          icon: conicon,
          text: "展业动态",
          tip: 2,
          src: ""
        }
      ],
      btnlist: [],
      btnlist1: [
        {
          src: require("../../assets/home/redicon.png"),
          text: "健康红包",
          tip: 1,
          url: ""
        },
        {
          src: require("../../assets/home/couponicon.png"),
          text: "展业优惠",
          tip: 2,
          url: "/en/discount"
        },
        {
          src: require("../../assets/home/gifticon.png"),
          text: "展业礼品",
          tip: 3,
          url: ""
        },
        {
          src: require("../../assets/home/PAC.png"),
          text: "PAC拜访签到",
          tip: 4,
          url: ""
        },
        {
          src: require("../../assets/home/renmaiicon.png"),
          text: "人脉管理",
          tip: 5,
          url: ""
        }
      ],
      btnlist2: [
        {
          src: require("../../assets/home/redicon.png"),
          text: "健康红包",
          tip: 1,
          url: ""
        },
        {
          src: require("../../assets/home/couponicon.png"),
          text: "展业优惠",
          tip: 2,
          url: ""
        },
        {
          src: require("../../assets/home/gifticon.png"),
          text: "展业礼品",
          tip: 3,
          url: ""
        },
        {
          src: require("../../assets/home/PAC.png"),
          text: "展业动态",
          tip: 5,
          url: ""
        },
        {
          src: require("../../assets/home/renmaiicon.png"),
          text: "人脉管理",
          tip: 6,
          url: ""
        }
      ]
    };
  },
  mounted() {
    this.getNews();
    
    if (replaceState.isWeichat()) {
      this.isWeichat = true;
      this.iconlist = this.iconlist2;
      this.btnlist = this.btnlist2;
      this.getTrialMsg()
    } else if (replaceState.isYzl()) {
      this.iconlist = this.iconlist1;
      this.btnlist = this.btnlist1;
    }
  },
  methods: {
    //获取新闻
    getNews() {
      let data = {
        Page: this.page,
        PageSize: this.pageSize
      };
      textService.prototype.GetNewsList(data).then(res => {
        this.allPage = res.PageNum;
        if (res.Data) {
          this.newsList.push(...res.Data);
        }
      });
    },
    //新闻翻页
    LoadMore() {
      if (this.page < this.allPage) {
        this.page++;
        this.getNews();
      }
    },
    btnclick(item) {
      this.popShow = false;
      if (item.url) {
        this.$router.push(item.url);
      } else {
        if (item.tip == 1) {
          this.getshandong();
        }else if(item.tip==2){
             this.$router.push('/making')
        } else if (item.tip == 3) {
          //礼品
          if (replaceState.isWeichat()) {
            window.location.href = params.WEB_SHOP_URL;
          } else if (replaceState.isYzl()) {
            window.location.href = params.SHOP_URL;
          }
        } else if (item.tip == 4) {
          //拜访签到
          window.location.href = "https://helen.longqueyun.com/visit";
        } else if (item.tip == 5) {
          //人脉管理
          this.getuser();
        } else if (item.tip == 6) {
          this.$router.push("/test/userList");
        }
      }
    },
    getpocket() {
      if (replaceState.isWeichat()) {
        window.location.href = params.WEB_SHOP_URL + "/product/14";
      } else if (replaceState.isYzl()) {
        window.location.href = params.SHOP_URL + "/product/14";
      }
    },
    //评估
    clickItem(item) {
      if (item.src) {
        this.$router.push(item.src);
      } else {
        if (item.tip == 1) {
          this.popShow = true;
        } else {
          this.getuser();
        }
      }
    },
      //使用版到期提醒
    getTrialMsg(){
      applyService.prototype.getTrialMsg().then(res=>{
          if(res){
             this.popupvisible=true
             this.message=res
           }
      })
    },
    //关闭提醒
    overclose(){
     this.popupvisible=false
    },
    //山东红包
    getshandong() {
      Indicator.open();
      userService.prototype
        .GetUserById({})
        .then(res => {
          Indicator.close();
          if (res.is_yantai == 1) {
            this.$router.push("/shand/purchased");
          } else {
            this.$router.push("/shand/healthgift");
          }
        })
        .catch(err => {
          Indicator.close();
        });
    },
    //用户签到
    SignDay() {
      jifenService.prototype
        .SignDay({})
        .then(res => {
          this.$router.push("/jifen/center");
        })
        .catch(err => {
          this.$router.push("/jifen/center");
        });
    },
    //点击新闻
    NewsClick(item) {
      if (item.href) {
        window.location.href = item.href;
      } else {
        this.$router.push({
          path: `/text/content/${item.id}`
        });
      }
    },
    //健康排名
    healthRank() {
      this.$router.push("/health/rank");
    },
    //用户信息
    getuser() {
      Indicator.open();
      userService.prototype
        .GetUserById({})
        .then(res => {
          Indicator.close();
          this.$store.commit("setUserInfo", res);
          this.ahshow = res.is_cooperation;
          this.id = res.fanxian_product_id;
          this.getMonthCard();
        })
        .catch(err => {
          Indicator.close();
        });
    },
    //判断用户是否有参团
    getMonthCard() {
      Indicator.open();
      userService.prototype
        .GetUserById({})
        .then(res => {
          Indicator.close();
          var url = encodeURIComponent("/home");
          if (res.is_user_right != 1) {
            this.$router.push({ path: "/ah/buy", query: { firsturl: url } });
          } else if (res.is_user_right == 1) {
            this.$router.push({ path: "/ah/job", query: { firsturl: url } });
          }
        })
        .catch(err => {
          Indicator.close();
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/home/home.vue